<template>
  <div class="CSChatThai BGwhite">
    <v-card-text class="scrolling-wrapper" style="margin-top:0vh; margin-bottom:0vh; justify-content: center !important; max-height: 94vh; color: rgb(74, 74, 74) !important;">
      <v-container grid-list-md style="padding-left: 90px; padding-right: 90px;">
        <v-layout wrap>
          <v-flex sm12 md12 lg12 xl12 style="display: flex; justify-content: center;">
            <div  class="List_item_body">
              <div class="SettingImg">
                <div class="SettingImgWrap">
                  <div>
                    <img :src="profilepicture" class="alligator-turtle" @click="Editpictureprofile" v-if="profilepicture !== ''" style=" cursor: pointer;width: 160px;height: 160px;">
                    <img src='/static/img/default_profile/business-white.png' class="alligator-turtle" style=" cursor: pointer; width: 160px;height: 160px;" v-else-if="typeuser === 'business'" @click="Editpictureprofile">
                    <img src='/static/img/default_profile/man-white.png' class="alligator-turtle" style=" cursor: pointer; width: 160px;height: 160px;" v-else @click="Editpictureprofile">
                    <div style="display: none;">
                      <input class="CSChatThai" type="file" name="file1"  @change="previewImageprofiles" accept="image/*" id="uploadpicprofilechat"/>
                    </div>
                    <label for="SettingImg" class="SettingImgBtn" @click="Editpictureprofile">
                      {{$t('Settings.editProfile.changePictureProfile')}}
                    </label>
                  </div>
                <!--   <input data-v-0c521aa4="" type="file" name="file" id="uploadpicprofilechat" class="SettingImgInput" @change="previewImageprofiles"> -->
                </div>
              </div>
              <p class="EditAreaNote">{{$t('Settings.editProfile.support')}} .JPEG/.PNG/.GIF</p><p class="EditAreaNote"></p><p class="EditAreaNote"></p>
            </div>
          </v-flex>
          <v-flex sm12 md12 lg12 xl12>
            <h3  class="header">{{$t('Settings.editProfile.profile')}}</h3>
          </v-flex>
          <v-flex sm12 md12 lg12 xl12>
            <div class="Setting">
            <!---->
              <div  class="SettingBlock">
                <p class="SettingTtl">{{$t('Settings.editProfile.displayName')}}</p>
                <div>
                  <div class="EditArea" v-if="!editname">
                    <div class="EditAreaCont BreakWord" v-if="!loadingname">{{ name }}</div>
                    <div v-else class="EditAreaCont BreakWord">
                      <v-progress-linear :indeterminate="loadingname"></v-progress-linear>
                    </div>

                    <v-btn flat small dark class="buttonedit" @click="editname = !editname">
                      <span >{{$t('AnswerQuestion.edit')}}</span>
                    </v-btn>
                  </div>
                  <div class="EditArea" v-else>
                    <div  class="EditAreaCont">
                      <div  class="EditAreaContFlex"><!---->
                        <input type="text" :placeholder="$t('Settings.editProfile.displayName')" class="InputEdit" v-model="nameedit">
                      </div>
                      <p class="EditAreaNote" style="color:red;" v-if="nameedit == ''">{{ alerterror }}</p>
                    </div>
                    <v-btn flat small dark class="buttonedit" @click="updatename()" >
                      <span>{{$t('AnswerQuestion.update')}}</span>
                    </v-btn>
                    <v-btn flat small class="buttoncancel" @click="cancelname()">
                      <span>{{$t('AnswerQuestion.cancel')}}</span>
                    </v-btn>
                  </div>
                </div>
              </div>
              <!--  -->
              <div  class="SettingBlock">
                <p class="SettingTtl">{{$t('Settings.editProfile.status')}}</p>
                <div>
                  <div class="EditArea" v-if="!editstatus">
                    <div class="EditAreaCont BreakWord" v-if="status !== ''">{{ status }}</div>
                    <div class="EditAreaCont BreakWord" v-else>-</div>
                    <v-btn flat small dark class="buttonedit" @click="editstatus = !editstatus">
                      <span >{{$t('AnswerQuestion.edit')}}</span>
                    </v-btn>
                  </div>
                  <div class="EditArea" v-else>
                    <div  class="EditAreaCont">
                      <div  class="EditAreaContFlex"><!---->
                        <input type="text" :placeholder="$t('Settings.editProfile.status')" class="InputEdit" v-model="statusedit" @keyup.enter="updatestatus()">
                      </div>
                    </div>
                    <v-btn flat small dark class="buttonedit" @click="updatestatus()">
                      <span >{{$t('AnswerQuestion.update')}}</span>
                    </v-btn>
                    <v-btn flat small class="buttoncancel" @click="cancelstatus()">
                      <span >{{$t('AnswerQuestion.cancel')}}</span>
                    </v-btn>
                  </div>
                </div>
              </div>
              <!--  edit phone -->
               <div  class="SettingBlock">
                <p class="SettingTtl">{{$t('Settings.editProfile.phone')}}</p>
                  <div class="EditArea" v-if="!editphone">
                    <div class="EditAreaCont BreakWord" v-if="!loadingphone">{{ phone }}</div>
                    <div v-else class="EditAreaCont BreakWord">
                      <v-progress-linear :indeterminate="loadingphone"></v-progress-linear>
                    </div>
                    <v-btn flat small dark class="buttonedit" @click="statusEditphone()" >
                      <span >{{$t('AnswerQuestion.edit')}}</span>
                    </v-btn>
                  </div>
                  <div class="EditArea" v-else>
                    <div  class="EditAreaCont">
                      <div  class="EditAreaContFlex">
                        <input type="text" :placeholder="$t('Settings.editProfile.phone')" class="InputEdit" v-model="phoneedit">
                      </div>
                      <p class="EditAreaNote" style="color:red;" v-if="nameedit == ''">{{ alerterror }}</p>
                    </div>
                    <v-btn flat small dark class="buttonedit" style="color:white;"  :loading="loadingUpdatePhone" @click="updatephone()" :disabled="disableupdatephone()">
                      <span>{{$t('AnswerQuestion.update')}}</span>
                    </v-btn>
                    <v-btn flat small class="buttoncancel" @click="cancelphone()">
                      <span>{{$t('AnswerQuestion.cancel')}}</span>
                    </v-btn>
                  </div>
              </div>
              <!---->
              <div  class="SettingBlock">
                <p class="SettingTtl">{{$t('Settings.editProfile.email')}}</p>
                <div>
                  <div class="EditArea">
                    <div class="EditAreaCont BreakWord">{{ email }}</div>
                  </div>
                </div>
              </div>
            </div>
          </v-flex>

          <!-- edit usrname and password -->
          <v-flex sm12 md12 lg12 xl12 v-if="status_username === 'false'">
            <h3 class="header">{{$t('Settings.editProfile.settingusername')}}</h3>
          </v-flex>
          <v-flex sm12 md12 lg12 xl12 v-if="status_username === 'false'">
            <div class="Setting">
            <!---->
              <div class="SettingBlock">
                <!-- <p class="SettingTtl">{{$t('Settings.editProfile.usernamepassword')}}</p> -->
                <div>
                  <div class="EditArea" v-if="!editusername">
                    <div class="EditAreaCont BreakWord" v-if="!loadingname">{{$t('Settings.editProfile.usernamepassword')}}</div>
                    <div v-else class="EditAreaCont BreakWord">
                      <v-progress-linear :indeterminate="loadingname"></v-progress-linear>
                    </div>

                    <v-btn flat small dark class="buttonedit" @click="editusername = !editusername">
                      <span >{{$t('AnswerQuestion.edit')}}</span>
                    </v-btn>
                  </div>
                  <div class="EditArea" style="align-items: start !important;" v-else>
                    <div class="EditAreaCont">
                      <!-- <div class="EditAreaContFlex">
                        <input type="text" :placeholder="$t('Settings.editProfile.username')" class="InputEdit" v-model="usernameedit">
                      </div>
                      <p class="EditAreaNote" style="color:red;" v-if="usernameedit == ''">{{ username_alerterror }}</p>

                      <div class="EditAreaContFlex mt-3">
                        <input type="text" :placeholder="$t('Settings.editProfile.password')" class="InputEdit" v-model="password">
                      </div>
                      <p class="EditAreaNote" style="color:red;" v-if="password == ''">{{ password_alerterror }}</p>

                      <div class="EditAreaContFlex mt-3">
                        <input type="text" :placeholder="$t('Settings.editProfile.confirmpassword')" class="InputEdit" v-model="confirmpassword">
                      </div>
                      <p class="EditAreaNote" style="color:red;" v-if="confirmpassword == ''">{{ confirm_alerterror }}</p> -->
                      <v-text-field
                        :placeholder="$t('Settings.editProfile.username')"
                        v-model="username"
                        :rules="usernameRules"
                        :error="chkUsernameDuplicate"
                        :error-messages="msgUsernameDuplicate"
                        @input="changeUsername"
                        @keypress="isNumandaz($event)"
                        autocapitalize="off"
                        required
                        solo
                      ></v-text-field>

                      <v-text-field
                        :placeholder="$t('Settings.editProfile.password')"
                        v-model="password"
                        :append-icon="e1 ? 'visibility' : 'visibility_off'"
                        :append-icon-cb="() => (e1 = !e1)"
                        :type="e1 ? 'text' : 'password'"
                        :rules="passwordRules"
                        required
                        solo
                        @keypress="isnotthai($event)"
                      ></v-text-field>

                      <v-text-field
                        :placeholder="$t('Settings.editProfile.confirmpassword')"
                        v-model="confirmpassword"
                        :append-icon="e2 ? 'visibility' : 'visibility_off'"
                        :append-icon-cb="() => (e2 = !e2)"
                        :type="e2 ? 'text' : 'password'"
                        :rules="repasswordRules"
                        required
                        solo
                        @keypress="isnotthai($event)"
                      ></v-text-field>
                    </div>
                    <v-btn flat small dark class="buttonedit" :disabled="checkData()" @click="updateusername()">
                      <span>{{$t('AnswerQuestion.update')}}</span>
                    </v-btn>
                    <v-btn flat small class="buttoncancel" @click="cancelusername()">
                      <span>{{$t('AnswerQuestion.cancel')}}</span>
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>
          </v-flex>

          <v-flex sm12 md12 lg12 xl12 >
            <h3  class="header">{{$t('Settings.editProfile.qrcodeForAddFriend')}}</h3>
          </v-flex>
          <v-flex sm12 md12 lg12 xl12 >
            <div class="Setting">
             <div class="SettingBlock">
              <div style="text-align: center;">
                <!-- <p class="SettingTtl" >QR code</p>  -->
                <p class="">
                  <qrcode :value="tokenuserQR" style="margin: 0 !important;height: 200px; width: 200px;padding: 5px;border: 3px solid; border-radius: 10px;" id="downloadqr-web"></qrcode>
                </p>
                <p class="">{{$t('Settings.editProfile.detailQRcode')}}
                <a href="#" class="button" id="btn-download-web" :download="'qrcode_user_' + name + '.png'" @click="loadqr()">{{$t('AnswerQuestion.download')}}</a></p>
              </div>
              </div>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <Editpictureprofile :dialogEditpictureprofile="dialogEditpictureprofile" @closeEditpictureprofile="closeEditpictureprofile"></Editpictureprofile>
    <Dialogeditphone :dialogeditphone="dialogeditphone" @closeDialogEditPhone="closeDialogEditPhone" :phoneedit="phoneedit" :phone="phone" @newphonnum="newphonnum"/>
  </div>
</template>
<script>
import Editpictureprofile from '@/components/chat/dialog/settings/Editpictureprofile'
import Dialogeditphone from '@/components/chat/dialog/settings/Dialogeditphone'
import { sync } from 'vuex-pathify'
import Vue from 'vue'
import VueQrcode from '@xkeshi/vue-qrcode'
import { Decode } from '@/services'
Vue.component(VueQrcode.name, VueQrcode)

export default {
  data () {
    return {
      dialogeditphone: false,
      phoneedit: '',
      loadingphone: false,
      loadingname: false,
      loadingstatus: false,
      phone: '',
      email: '',
      token: '',
      name: '',
      status: '',
      profilepicture: '',
      nameedit: '',
      statusedit: '',
      editname: false,
      editstatus: false,
      typeuser: '',
      alerterror: '',
      tokenuserQR: '',
      dialogEditpictureprofile: false,
      username: '',
      usernameedit: '',
      editusername: false,
      password: '',
      confirmpassword: '',
      username_alerterror: '',
      password_alerterror: '',
      confirm_alerterror: '',
      usernameRules: [
        v => !!v || '' || this.$t('Settings.messageError.UsernameRules1'),
        v => ((!v && v.length < 6) || /^[^\W_]+$/.test(v)) || this.$t('Settings.messageError.UsernameRules2'),
        v => (!!v && v.length >= 6) || this.$t('Settings.messageError.UsernameRules3'),
        v => /^([^A-Z])+$/.test(v) || this.$t('Settings.messageError.UsernameRules4'),
        v => /^([a-z])+$/.test(v) || /^((?=.*[a-z])(?=.*[0-9]).{6,})+$/.test(v) || this.$t('Settings.messageError.UsernameRules5'),
        v => this.checkUsernameDuplicate() || ''
      ],
      chkUsernameDuplicate: false,
      msgUsernameDuplicate: [],
      e1: false,
      e2: false,
      repasswordRules: [
        v => !!v || this.$t('Settings.messageError.RePasswordRules1'),
        v => v === this.password || this.$t('Settings.messageError.RePasswordRules2')
      ],
      passwordRules: [
        v => !!v || this.$t('Settings.messageError.PasswordRules1'),
        v => /^((?=.*[a-zA-Z])(?=.*[0-9]).{8,})+$/.test(v) || this.$t('Settings.messageError.RePasswordRules2')
      ],
      status_username: '',
      editphone: false,
      editphone_success: '',
      loadingUpdatePhone: false
    }
  },
  methods: {
    updateusername () {
      var body = {
        'tokenuser': this.token,
        'username': this.username,
        'password': this.password
      }
      // console.log(process.env.APImanage + '/set_username', body)
      this.loadingname = true
      this.axios.post(process.env.APImanage + '/set_username', body).then((response) => {
        // console.log(response.data)
        if (response.data.status === 'success') {
          this.loadingname = false
          this.$swal('', this.$t('Alert.Success.settingusername'), 'success')
          localStorage.setItem('status_username', 'true')
          this.status_username = 'true'
        } else {
          this.loadingname = false
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
          localStorage.setItem('status_username', 'false')
          this.status_username = 'false'
          this.cancelusername()
        }
      }).catch(error => {
        console.log(error)
        this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
      })
    },
    checkData () {
      return (this.username === '' || this.password === '' || this.confirmpassword === '')
    },
    changeUsername () {
      if (this.chkChangeUsername) {
        this.chkChangeUsername = false
        this.msgUsernameDuplicate = []
        this.chkUsernameDuplicate = false
      }
    },
    checkUsernameDuplicate () {
      // console.log(this.username)
      if (this.username !== '') {
        this.axios.get(process.env.ONEID_API + '/check_username?username=' + this.username).then((response) => {
          // console.log(response.data)
          if (response.status === 200) {
            if (response.data.message === 'Success') {
              this.chkUsernameDuplicate = false
              this.msgUsernameDuplicate = []
            }
          }
        }, (error) => {
          if (error.response.status === 400) {
            if (error.response.data.errorMessage === 'username duplicate') {
              this.chkUsernameDuplicate = true
              this.msgUsernameDuplicate = [this.$t('Settings.messageError.UsernameDuplicate')]
              this.valid = false
            } else if (this.username === '') {
              this.msgUsernameDuplicate = [this.$t('Settings.messageError.UsernameRules1')]
            }
          }
        })
        return true
      }
    },
    isNumandaz ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      // console.log(keyCode)
      if (!(keyCode >= 48 && keyCode <= 57) && !(keyCode >= 97 && keyCode <= 122)) { // 46 is dot
        $event.preventDefault();
      }
    },
    isnotthai ($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode >= 3585 && keyCode <= 3642) || (keyCode >= 3647 && keyCode <= 3675)) { // 46 is dot
        $event.preventDefault();
      }
    },
    Editpictureprofile () {
      this.dialogEditpictureprofile = true
    },
    closeEditpictureprofile (value) {
      this.dialogEditpictureprofile = value
    },
    uppictest () {
      $('#uploadpicprofilechat').click()
    },
    uppic () {
      $('#uploadpicprofilechat').click()
    },
    cancelstatus () {
      this.editstatus = !this.editstatus
      this.statusedit = this.status
    },
    cancelname () {
      this.editname = !this.editname
      this.nameedit = this.name
    },
    cancelusername () {
      this.editusername = !this.editusername
      // this.usernameedit = this.username
      this.username = ''
      this.password = ''
      this.confirmpassword = ''
    },
    updatename () {
      this.editname = !this.editname
      if (this.nameedit !== '') {
        if (this.nameedit !== this.name) {
          this.loadingname = true
          this.axios.post(process.env.APImanage + '/setnameuser', {tokenuser: this.token, name: this.nameedit}).then((response) => {
            if (response.data.status === 'success') {
              this.name = this.nameedit
              localStorage.setItem('name', this.nameedit)
              this.myname = this.nameedit
              this.loadingname = false
            } else {
              this.loadingname = false
              this.nameedit = this.name
              // console.log(response.data)
              this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
            }
          }, () => {
            this.loadingname = false
            this.nameedit = this.name
            this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
          })
        }
      } else {
        this.nameedit = ''
        this.alerterror = this.$t('Alert.Fail.nameuser')
        this.editname = !this.editname
        this.loadingname = false
      }
    },
    updatestatus () {
      this.editstatus = !this.editstatus
      if (this.statusedit !== this.status) {
        this.loadingstatus = true
        this.axios.post(process.env.APImanage + '/setstatususer', {tokenuser: this.token, status: this.statusedit}).then((response) => {
          if (response.data.status === 'success') {
            localStorage.setItem('status', this.statusedit)
            this.status = this.statusedit
            this.loadingstatus = false
          } else {
            this.loadingstatus = false
            this.statusedit = this.status
            // console.log(response.data)
            this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
          }
        }, () => {
          this.loadingstatus = false
          this.statusedit = this.status
          this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
        })
      }
      // }
    },
    previewImageprofiles (data) {
      this.selectFile = data.target.files[0]
      var uploadFile = new FormData()
      uploadFile.append('file', this.selectFile, this.selectFile.name)
      uploadFile.append('tokenuser', this.token)
      uploadFile.append('type_user', this.typeuser)
      this.axios.post(process.env.APIgo_api + '/v1/set-picture-profile', uploadFile).then((response) => {
        if (response.data.status === 'success') {
          this.profilepicture = response.data.filename
          localStorage.setItem('profilepicture', this.profilepicture)
          this.myprofilepicture = this.profilepicture
        }
      })
    },
    loadqr () {
      var cnvs = document.getElementById('downloadqr-web')
      var button = document.getElementById('btn-download-web')
      var dataURL = cnvs.toDataURL('image/png')
      button.href = dataURL
    },
    updatephone () {
      this.loadingUpdatePhone = true
      this.axios.post(process.env.APImanage + '/check_phone_login', {
        phone: this.phoneedit
      }).then((response) => {
        // console.log(response)
        if(response.data.status === 'success'){
          // this.loadingUpdatePhone = false
          if(response.data.message === 'non registered'){
            // localStorage.typeAccount = true
          }else if(response.data.message === 'registered'){
            // localStorage.typeAccount = false
          }
          // this.editphone = !this.editphone
          this.ShowdialogEditPhonenum()
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    cancelphone () {
      this.editphone = !this.editphone
      this.phoneedit = this.phone
    },
    closeDialogEditPhone (value){
      this.dialogeditphone = value
      // this.loadingUpdatePhone = false
      // this.phone = localStorage.phone
      // this.phoneedit = localStorage.phoneedit
      // this.phoneedit = this.phone
    },
    newphonnum(value){
      this.phone = value
    },
    ShowdialogEditPhonenum () {
      this.dialogeditphone = true
    },
    statusEditphone () {
      this.$swal({
        title: this.$t('Settings.messageEditPhone.ChangePhoneNumber'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '',
        confirmButtonText: this.$t('AnswerQuestion.ok'),
        cancelButtonText: this.$t('AnswerQuestion.cancel'),
        confirmButtonClass: 'btn btn-danger',
        cancelButtonClass: 'btn btn-success',
        buttonsStyling: true,
        showCloseButton: true,
        reverseButtons: true
      }).then((result) => {
        if(result.value === true){
          this.editphone = !this.editphone
        }else{
        }
      })
    },
    disableupdatephone () {
      if(this.phoneedit == '' || this.phoneedit == this.phone){
        return true
      }else{
        return false
      }
    },
  },
  computed: {
    ...sync('*')
  },
  watch: {
    myprofilepicture () {
      this.profilepicture = localStorage.getItem('profilepicture')
    },
    myname () {
      this.name = localStorage.getItem('name')
    },
    mystatus () {
      this.status = localStorage.getItem('status')
    },
    dialogeditphone(){
      this.phone = localStorage.phone
      if(this.dialogeditphone === false){
        this.editphone_success = localStorage.editphone_success
        if(this.editphone_success === 'false'){
          this.loadingUpdatePhone = false
          this.editphone = !this.editphone
          this.phoneedit = this.phone
        }else if(this.editphone_success === 'true') {
          this.phone = this.phoneedit
          this.loadingUpdatePhone = false
          this.editphone = !this.editphone
        }
      }
    }
  },
  components: {
    Editpictureprofile,
    Dialogeditphone
  },
  created () {
    this.phone = localStorage.getItem('phone')
    this.email = localStorage.getItem('email')
    var decoded =  JSON.parse(Decode.decode(localStorage.getItem('Authenrization')))
    this.token = decoded['tokenuser']
    // this.username = decoded_username['username']
    this.status_username = localStorage.getItem('status_username')
    // this.status_username = 'true'
    // console.log(this.status_username)
    // if (this.status_username === 'false') {
    //   this.username = ''
    // }
    // this.tokenuserQR = 'https://com.oneplatform.android.onechat/u/' + btoa(this.$cookie.get('tokenuser'))
    this.tokenuserQR = process.env.APIQRcode + '/qrcode/friend?id=' + btoa(this.token)
    this.name = localStorage.getItem('name')
    this.status = localStorage.getItem('status')
    this.profilepicture = localStorage.getItem('profilepicture')
    this.typeuser = localStorage.getItem('type_user')
    this.nameedit = this.name
    this.phoneedit = this.phone
    this.statusedit = this.status
  }
}
</script>
<style type="text/css" scoped>
.border-textfield {
  width: 100% !important;
  box-sizing: border-box !important;
  background-color: rgb(255, 255, 255) !important;
  border: 1px solid rgb(210, 216, 221) !important;
  border-radius: 4px !important;
}
>>>.v-input__slot {
  width: 100% !important;
  box-sizing: border-box !important;
  background-color: rgb(255, 255, 255) !important;
  border: 1px solid rgb(210, 216, 221) !important;
  border-radius: 4px !important;
}
>>>.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) .v-input__slot {
  box-shadow: none !important;
}
>>>.v-messages__message {
  line-height: 1 !important;
  word-break: break-word !important;
  word-wrap: break-word !important;
  hyphens: auto !important;
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}
.scrolling-wrapper {
  /*display: flex;*/
  overflow-y: auto;
}
.scrolling-wrapper::-webkit-scrollbar {
  height: 4px;
  width: 8px;
}
.scrolling-wrapper::-webkit-scrollbar-thumb {
  border-radius: 8px;
  background: rgba(0, 0, 0, .1);
}
.Kanit{
  font-family: 'Kanit', sans-serif !important;
}
.edit {
  font-weight: 100;
}
.inputWrapper {
    height: 32px;
    width: 90px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
}
.img {
  display: block;
  max-width:230px;
  max-height:95px;
  width: auto;
  height: auto;
}
.alligator-turtle {
  object-fit: cover;
  object-position: 50% 0;
}
.dialog .dialog--active .dialog--persistent {
  max-height: 107vh;
  overflow: hidden;
}
.card__text {
  padding-left: 16px;
  padding-right: 16px;
  padding-bottom: 16px;
  overflow: hidden;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.textbusiness {
  margin-top: 1vh;
  font-family: 'CS ChatThaiUI' !important;
  word-wrap: break-word;
  /*width: 300px;*/
}
input[type=textprofile] {

    width: 100%;
    box-sizing: border-box;
    border: 2px solid #ccc;
    border-radius: 4px;
    font-size: 16px;
    background-color: white;
    /*background-image: url('../assets/image/group.png');*/
    background-position: 10px 10px;
    background-repeat: no-repeat;
    padding: 10px 10px 10px 10px;
    -webkit-transition: width 0.4s ease-in-out;
    transition: width 0.4s ease-in-out;
}
input[type=textprofile]:disabled {
    background: #cac9c9;
}
.EndpointUrl:hover .urlcopymessageapi {
  display: inline !important;
}
.urlcopymessageapi {
  display: none !important;
}
.EndpointUrl {
  display: block;
  /*color: #6D7D8D;*/
}
.header {
    display: block;
    font-size: 1.17em;
    -webkit-margin-before: 1em;
    -webkit-margin-after: 1em;
    -webkit-margin-start: 0px;
    -webkit-margin-end: 0px;
    /*margin: 40px 0 20px;*/
    padding-left: 20px;
    line-height: 1.3;
    font-weight: bold;
    font-size: 16px;
    position: relative;
    color: black !important;
}
.header::before {
    content: "";
    display: inline-block;
    position: absolute;
    top: 50%;
    -webkit-transform: translateY(-50%);
    transform: translateY(-50%);
    left: 0;
    width: 0;
    height: 32px;
    border-left: 4px solid #1a76d2;
}
.Setting {
    margin-bottom: 2vh;
}
.SettingBlock {
    padding: 20px 20px;
    border-top: 1px solid #DEE5EC;
}
.SettingBlock > :last-child {
    margin-bottom: 0;
}
/*.List_Register {
    margin-bottom: 32px;
    box-sizing: border-box;
}
.List_Register .List_item:last-child {
    border-bottom: none;
}
.List_Register .List_item {
    display: -webkit-flex;
    display: flex;
    padding: 0;
}
.List_Register .List_item:last-child .List_item_header {
    width: 200px;
}*/
.SettingTtl {
    margin-bottom: 8px;
    font-weight: bold;
    white-space: nowrap;
    color: black !important;
}
.md91SettingImg {
    padding-bottom: 12px;
    line-height: 1;
}
.SettingImgWrap {
    display: inline-block;
    position: relative;
    border-radius: 20px;
    overflow: hidden;
}
.SettingImgMask {
   position: relative;
    width: 160px;
    height: 160px;
    overflow: hidden;
    border-radius: 40px;
}

.SettingImgBtn {
    display: block;
    overflow: hidden;
    position: absolute;
    bottom: -20px;
    right: -20px;
    line-height: 1;
    width: 40px;
    height: 30px;
    bottom: 0;
    left: 0;
    line-height: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, .5);
}

.SettingImgBtn:hover {
    display: block;
    overflow: hidden;
    position: absolute;
    bottom: -20px;
    right: -20px;
    line-height: 1;
    width: 40px;
    height: 50%;
    bottom: 0;
    left: 0;
    line-height: 30px;
    width: 100%;
    text-align: center;
    cursor: pointer;
    color: #fff;
    background: rgba(0, 0, 0, .75);
}
.SettingImgInput {
    position: absolute;
    left: -9999px;
}
.EditAreaNote {
    margin: 8px 0 0;
    font-size: 13px;
    color: #BEC8D2;
    font-size: 12px;
}
.EditArea {
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: center;
    align-items: center;
}
.BreakWord {
    white-space: pre-wrap;
    word-break: break-all;
    word-break: break-word;
    word-wrap: break-word;
}
.EditAreaCont {
    width: 100%;
    padding-right: 1em;
    box-sizing: border-box;
}
.SettingQr {
    display: -webkit-flex;
    display: flex;
}
.SettingQrImg {
    margin: 0 50px;
    position: relative;
}
.SettingQrNote {
    margin-bottom: 0;
    font-size: 13px;
}
.buttonedit {
  color: ghostwhite;
  border-radius: 4px;
  background-color: #2562af !important;
  border: solid 1px #2562af !important;
  -webkit-box-sizing: border-box !important;
  box-sizing: border-box !important;
  margin-right: 0 !important;
  text-align: center;
  font-weight: 400 !important;
  text-transform: none;
}
.buttoncancel {
  color: black;
  border-radius: 4px;
  background-color: #c1c1c196 !important;
  border: solid 1px #c1c1c1 !important;
  -webkit-box-sizing: border-box !important;
  box-sizing: border-box !important;
  margin-right: 0 !important;
  text-align: center;
  font-weight: 400 !important;
  text-transform: none;
}
.EditAreaContFlex {
    display: -webkit-flex;
    display: flex;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    -webkit-align-items: center;
    align-items: center;
}

.InputEdit {
    width: 100%;
    padding: 10px 15px;
    box-sizing: border-box;
    background-color: #fff;
    border: 1px solid #d2d8dd;
    border-radius: 4px;
}
.CSChatThai {
 font-family: 'CS ChatThaiUI' !important;
 word-wrap: break-word;
}
.BGwhite {
  background-color: white !important;
}
/*.avatarpicBis:hover .overlay {
  opacity: 1;

}*/
</style>



// WEBPACK FOOTER //
// src/components/chat/settings/EditProfile.vue